import { PayrollPeriod } from '@/models'
import {
    APP_GET_PAYROLL_PERIODS_FAILURE,
    APP_GET_PAYROLL_PERIODS_SUCCESS,
    APP_LOGOUT,
    AUTH_AUTHENTICATE_USER_SUCCESS,
    SET_APP_ERROR,
    SET_LOADING,
} from '@/redux/actionTypes'

export interface AppError {
    code: number
    message?: unknown
}

export interface AppState {
    loading: boolean
    error?: AppError | null
    toasts: unknown[]
    payrollPeriods: PayrollPeriod[]
}

export type AppAction =
    | { type: typeof SET_LOADING, loading: boolean }
    | { type: typeof SET_APP_ERROR, error: AppError | null }
    | { type: typeof APP_GET_PAYROLL_PERIODS_FAILURE, error?: AppError }
    | { type: typeof APP_GET_PAYROLL_PERIODS_SUCCESS, payrollPeriods: PayrollPeriod[] }
    | { type: typeof AUTH_AUTHENTICATE_USER_SUCCESS }
    | { type: typeof APP_LOGOUT }

const initialState: AppState = {
    loading: false,
    error: null,
    toasts: [],
    payrollPeriods: [],
}

export const appReducer = (state: AppState = initialState, action: AppAction): AppState => {
    switch (action.type) {
        case SET_LOADING:
            return { ...state, loading: action.loading }
        case SET_APP_ERROR:
        case APP_GET_PAYROLL_PERIODS_FAILURE:
            return { ...state, error: action.error }
        case APP_GET_PAYROLL_PERIODS_SUCCESS:
            return { ...state, payrollPeriods: action.payrollPeriods }
        case AUTH_AUTHENTICATE_USER_SUCCESS:
            return { ...state, toasts: [] }
        case APP_LOGOUT:
            return { ...initialState }
        default:
            return state
    }
}
